<div class="bg-green-100 container mx-auto max-w-screen-sm h-screen flex flex-col">
    <!-- Header -->
    <div class="pl-4 pr-6 h-16 bg-green-500 text-white w-full flex items-center gap-2 font-bold flex-shrink-0">
        <!-- <div class="leading-[48px]">{{ selectedTab.title }}</div> -->
        <p-image [imageStyle]="{'border-radius': '8px', 'height': '40px', 'width': '44px', 'background': 'white' }"
            [src]="'https://firebasestorage.googleapis.com/v0/b/dev-anystoreapp.firebasestorage.app/o/app_icon%2Fshopper_icon.png?alt=media&token=75a7e316-fc22-4406-9725-1fe96000b793'"
            alt="Image" width="150" [preview]="false" />
        <div class="text-xl font-semibold text-white">AnyStore Shopper</div>

    </div>

    <!-- Content Area with Scroll -->
    <div class="flex-1 overflow-y-auto">
        <div class="">
            <app-home-tab *ngIf="selectedTab.value === 0"></app-home-tab>
            <app-batches-tab *ngIf="selectedTab.value === 1"></app-batches-tab>
            <app-earnings-tab *ngIf="selectedTab.value === 2"></app-earnings-tab>
            <app-profile-tab *ngIf="selectedTab.value === 3"></app-profile-tab>
        </div>
    </div>

    <!-- Bottom Navigation Tabs -->
    <div class="bg-white border-t border-gray-100 flex-shrink-0">
        <div class="flex">
            @for (tab of tabs; track tab.value) {
            <button class="flex-1 flex flex-col items-center justify-center py-3 px-2 transition-colors duration-200"
                [class]="selectedTab.value === tab.value ? 'text-white bg-green-500' : 'text-gray-500 hover:text-green-600'"
                (click)="onTabChange(tab)">
                <i class="pi pi-{{ tab.icon }} text-xl mb-1"></i>
                <span class="text-xs font-medium">{{ tab.title }}</span>
            </button>
            }
        </div>
    </div>
</div>